<template>
<form novalidate @submit.stop.prevent="register">
    <md-input-container>
        <label>First Name</label>
        <md-input v-model="newUser.firstName" required></md-input>
    </md-input-container>
    <md-input-container>
        <label>Last Name</label>
        <md-input v-model="newUser.lastName" required></md-input>
    </md-input-container>
    <md-input-container :class="{'md-input-invalid': emailError()}">
        <label>Email</label>
        <md-input v-model="newUser.email" type="email" required></md-input>
        <span class="md-error" v-if="emailError">{{errorMessage}}</span>
    </md-input-container >
    <md-input-container :class="{'md-input-invalid': passwordError()}">
        <label>Password</label>
        <md-input v-model="newUser.password" type="password" required></md-input>
        <span class="md-error" v-if="passwordError">{{errorMessage}}</span>
    </md-input-container>
    <md-input-container :class="{'md-input-invalid': confirmPasswordError()}">
        <label>Confirm Password</label>
        <md-input v-model="newUser.confirmPassword" type="password" required></md-input>
        <span class="md-error" v-if="confirmPasswordError">Passwords do not match</span>
    </md-input-container>
    <md-button class="md-raised md-primary" @click="register"><md-icon>person</md-icon>&nbsp;Register</md-button>
</form>
</template>

<script>
import firebase from 'firebase';

const RegisterForm = {
    name: 'RegisterForm',
    data: function() {
        return {
            newUser: {
                firstName: '',
                lastName: '',
                email: '',
                password: '',
                confirmPassword: ''
            },
            hasError: '',
            errorMessage: ''
        };
    },
    methods: {
        register() {
            const self = this;

            this.hasError = '';
            this.errorMessage = '';
            firebase.auth().createUserWithEmailAndPassword(this.newUser.email, this.newUser.password)
            .then((user) => {
                user.updateProfile({
                    displayName: `${this.newUser.firstName} ${this.newUser.lastName}`
                }).then(() => {
                    user.signInMethod = 'email';
                    console.log(user);
                    self.$emit('success', user);
                });

                user.sendEmailVerification();
            }).catch((error) => {
                // Handle Errors here.
                console.log(error.code);
                this.hasError = error.code;
                this.errorMessage = error.message;
            });
        },
        emailError() {
            return this.hasError === 'auth/invalid-email' ||
                    this.hasError === 'auth/email-already-in-use';
        },
        passwordError() {
            return this.hasError === 'auth/weak-password';
        },
        confirmPasswordError() {
            return (this.newUser.password && this.newUser.confirmPassword) && 
                (this.newUser.password !== this.newUser.confirmPassword);
        }
    }
};
export default RegisterForm;
</script>

<style lang="scss">
</style>


// WEBPACK FOOTER //
// register-form.vue?7a419775